import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useState } from "react";
import { Button } from "rsuite";
import { statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import CheckRoundIcon from "@rsuite/icons/CheckRound";
import BlockRoundIcon from "@rsuite/icons/BlockRound";
import { Trash, FileDownload } from "@rsuite/icons";

const CommercialBulkAction = ({
  checkedKeys,
  setCheckedKeys,
  onBulkPublish,
  onBulkDelete,
  onExportCommercial,
  ...props
}: {
  checkedKeys: any;
  setCheckedKeys: Function;
  onBulkPublish?: any;
  onBulkDelete?: any;
  onExportCommercial?: any;
}) => {
  const { t } = useTranslation();
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [openBulkPublishModal, setOpenBulkPublishModal] = useState(false);
  const [openExportCommercialModal, setOpenExportCommercialModal] =
    useState(false);
  const [openBulkDeleteModal, setOpenBulkDeleteModal] = useState(false);
  const [bulkActionMessage, setBulkActionMessage] = useState("");
  const [bulkActionTitle, setBulkActionTitle] = useState("");
  const [bulkPublishStatus, setBulkPublishStatus] = useState("");

  function bulkPublish(status: string) {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkPublishModal(true);
    setBulkPublishStatus(status);
    let msg = t("CONFIRM_ACTION", {
      action:
        status == statusArr.active
          ? t("PUBLISH").toLowerCase()
          : t("UNPUBLISH").toLowerCase(),
      entity: t("COMMERCIAL").toLowerCase(),
    });
    setBulkActionMessage(msg);
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: "",
      })
    );
  }

  function bulkDelete() {
    if (checkedKeys.length === 0) {
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkDeleteModal(true);

    setBulkActionMessage(
      t("CONFIRM_ACTION", {
        action: t("DELETE").toLowerCase(),
        entity: t("Commercial").toLowerCase(),
      })
    );
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: t("DELETE").toLowerCase(),
      })
    );
  }

  return (
    <div className="commercial-action col-md-8">
      <div className="commercial-action-toolbar">
        <div className="commercial-action-title">Bulk Actions</div>
        <div className="commercial-action-buttons">
          {UtilityServices.hasPermission("publish-commercial") && (
            <React.Fragment>
              <Button
                className="commercial-bulk-btn commercial-bulk-btn-publish"
                appearance="primary"
                onClick={() => bulkPublish("1")}
                startIcon={<CheckRoundIcon />}
              >
                {t("PUBLISH")}
              </Button>
              <Button
                className="commercial-bulk-btn commercial-bulk-btn-unpublish"
                appearance="ghost"
                onClick={() => bulkPublish("0")}
                startIcon={<BlockRoundIcon />}
              >
                {t("UNPUBLISH")}
              </Button>
            </React.Fragment>
          )}
          {UtilityServices.hasPermission("delete-commercial") && (
            <Button
              className="commercial-bulk-btn commercial-bulk-btn-delete"
              appearance="ghost"
              onClick={bulkDelete}
              startIcon={<Trash />}
            >
              {t("DELETE")}
            </Button>
          )}
          {UtilityServices.hasPermission("export-commercial") && (
            <Button
              className="commercial-bulk-btn commercial-bulk-btn-export"
              appearance="ghost"
              onClick={() => setOpenExportCommercialModal(true)}
              startIcon={<FileDownload />}
            >
              {t("EXPORT")}
            </Button>
          )}
        </div>
      </div>
      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={t("PLEASE_SELECT_RECORD_TO_ACTION")}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />
      <AlertModal
        open={openBulkPublishModal}
        handleClose={(e: any) => {
          if (e == true) {
            onBulkPublish(bulkPublishStatus);
            setOpenBulkPublishModal(false);
          } else {
            setOpenBulkPublishModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
      <AlertModal
        open={openBulkDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onBulkDelete();
            setOpenBulkDeleteModal(false);
          } else {
            setOpenBulkDeleteModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
      <AlertModal
        open={openExportCommercialModal}
        handleClose={(e: any) => {
          if (e == true) {
            onExportCommercial();
            setOpenExportCommercialModal(false);
          } else {
            setOpenExportCommercialModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION_ALL", {
          action: t("EXPORT").toLowerCase(),
          entity: t("Commercial").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("EXPORT").toLowerCase(),
        })}
      />
    </div>
  );
};

export default CommercialBulkAction;
